import { createAsyncThunk } from "@reduxjs/toolkit";

import type {
  IAddBundleProductsToCartMutation,
  IAddSimpleProductsToCartMutation,
  IBundleOptionInput,
} from "@jti/magento";
import { getCurrentMagentoClient } from "@jti/magento";
import type { MagentoGraphQLRequestClientError } from "@jti/magento-api-v2";

import { fetchCartItems } from "../fetchCartItems";

type AddProductToCartPayload = {
  cartId: string;
  sku: string;
  bundle?: IBundleOptionInput[];
  quantity?: number;
  isConsentGiven?: boolean;
  requestId?: string;
};

const addProductToCartDeclaration = (isFreeTrial: boolean) =>
  createAsyncThunk<
    IAddBundleProductsToCartMutation | IAddSimpleProductsToCartMutation,
    AddProductToCartPayload,
    {
      rejectValue: MagentoGraphQLRequestClientError;
    }
  >(
    isFreeTrial ? "freeTrialCart/addProductToCart" : "cart/addProductToCart",
    async (payload: AddProductToCartPayload, { dispatch, rejectWithValue }) => {
      try {
        const { bundle, cartId, sku, quantity, isConsentGiven } = payload;
        const magentoClient = getCurrentMagentoClient(isFreeTrial);
        const productResponse = await (bundle && bundle?.length > 0
          ? magentoClient.addBundleProductsToCart(cartId, sku, bundle, quantity, isConsentGiven)
          : magentoClient.addSimpleProductsToCart(cartId, sku, quantity, isConsentGiven));

        if (!isFreeTrial) {
          dispatch(fetchCartItems(cartId));
        }

        return productResponse;
      } catch (error) {
        return rejectWithValue(error as MagentoGraphQLRequestClientError);
      }
    }
  );

export const addProductToCart = addProductToCartDeclaration(false);
export const addFreeTrialProductToCart = addProductToCartDeclaration(true);
